import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import CarouselSlider from 'components/atoms/TemplateCarouselSlider';
import { Slide } from 'pure-react-carousel';
import ReactHtmlParser from 'react-html-parser';

/**
 * Text
 */
const ListCarousel = ({ boxStyle, item, viewType, onClickEvt, listKey }) => {
  const { items, type,id } = item;

  const listIdx= listKey;
  const slideBoxSet = boxStyle;
/*   if(items[0].button[0].label ==='차량관리'){
    slideBoxSet.width = 342;
  } */
  const slideBoxSetStyle = {
    width: `${slideBoxSet.width}px`,
    height: items[0].button.length * 45 + 25 + 'px',
    marginRight: `${slideBoxSet.margin}px`,
  };
  const slideLength = items.length;

  const constentSet = () => {
    return (
      <div key={`constentSet_${listIdx}`} id ={`constentSet_${listIdx}`}>
        {items.map((tempItem, idx) => {
          return (
            <Slide key={`slide_${listIdx}_${idx}`} className="_list_carousel_card" style={slideBoxSetStyle}>
              {tempItem.text.desc.includes('<img') === true ? (
                <div className="_list_carousel_card_img" id={`_list_carousel_${listIdx}_${idx}_image`}>
                  <div className="_img" id={`_list_carousel_${listIdx}_${idx}_img`}>{ReactHtmlParser(tempItem.text.desc)}</div>
                </div>
              ) : (
                <div className="_list_carousel_card_title" id={`_list_carousel_${listIdx}_${idx}_title`}>
                  <div className="_title" id={`_list_carousel_${listIdx}_${idx}_tit`}> {ReactHtmlParser(tempItem.text.desc)}</div>
                </div>
              )}
              {tempItem.button.map((data, number) => {
                return (
                  <>
                    {data.label !== '' ? (
                      <div className="_list_carousel_card_button" id={`_list_carousel_${listIdx}_${number}_button`}>
                        <div className="_button" id={`_list_carousel_${listIdx}_${number}_btn`} onClick={e => onClickEvt(data.value, data.action)}>
                          {ReactHtmlParser(data.label)}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </>
                );
              })}
            </Slide>
          );
        })}
      </div>
    );
  };
  return (
    <>
      <div className="_carousel_button_div" key={`cart_${listIdx}`}>
        <CarouselSlider key={`carSlider_${listIdx}`} slideBoxSet={slideBoxSet} contentCount={slideLength} contentSet={constentSet} listIdx={listIdx} />
      </div>
    </>
  );
};
ListCarousel.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
  listKey:PropTypes.string,
};
ListCarousel.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
  listKey:''
};

export default ListCarousel;
